/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { useState } from "react";
import { animated, useSpring } from "react-spring";
import './GalleryView.scss';
/**

@Author Karthik

@param

@return Item view html

**/

export const GalleryImage = ({ imageUrl, adjustHeight, adjustWidth, whenClick, setHeight }) => {
    const [props, set] = useSpring(() => ({ x: 0, y: 0 }));
    const [handleClientReact, setHandleClientReact] = useState({ clientRectX: 20, clientRectY: 8 });

    const mounseMove = (e) => {
        const reduceValue = window.innerWidth > 1370 ? 2 : 1;
        const clientRect = e.target.getBoundingClientRect();
        const { clientX, clientY } = e;
        const { left, top } = e.target.getBoundingClientRect();
        const x = clientX - left;
        const y = clientY - top;
        const clientRectX = parseFloat(parseFloat(clientRect.x / 13).toFixed(0));
        const clientRectY = parseFloat(parseFloat((clientRect.y / 10) - reduceValue).toFixed(0));
        setHandleClientReact({ clientRectX, clientRectY });
        set({ x, y });
    }

    return (
        <div className="App__wrapper">
            <main>
                <div className="App">
                    <animated.div
                        className="Simple"
                        onMouseMove={e => mounseMove(e)}
                        style={{
                            backgroundRepeat: "no-repeat",
                            backgroundPositionX: adjustWidth ? props.x.to(x => `${x / handleClientReact.clientRectX}%`) : "50%",
                            backgroundPositionY: adjustHeight ? props.y.to(y => `${y / handleClientReact.clientRectY}%`) : "50%",
                            backgroundImage: `url(${imageUrl})`,
                        }}
                        onClick={whenClick}
                    />
                </div>
            </main>
        </div>
    );
}
